import { Loader2 } from "lucide-react";
import { DEPLOY_STATUS, SITE_STATUS } from "./helpers";

export function SiteBadge({ status, testid }) {
  const [label, cls] = SITE_STATUS[status] || SITE_STATUS.bozza;
  return <span className={`inline-flex items-center whitespace-nowrap rounded-full border px-2 py-0.5 text-[11px] font-medium ${cls}`} data-testid={testid}>{label}</span>;
}

export function DeployBadge({ d, testid }) {
  const [label, cls] = DEPLOY_STATUS[d.status] || DEPLOY_STATUS.failed;
  const busy = ["queued", "building"].includes(d.status);
  const text = busy && d.cancel_requested ? "Annullamento…" : d.status === "building" ? d.phase_label || label : label;
  return (
    <span className={`inline-flex items-center gap-1 whitespace-nowrap rounded-full px-2 py-0.5 text-[11px] font-medium ${cls}`} data-testid={testid}>
      {d.status === "building" && <Loader2 size={11} className="animate-spin" />}{text}
    </span>
  );
}

export function ChecksChips({ c, testid }) {
  if (!c) return <span className="text-xs text-slate-400">—</span>;
  return (
    <span className="inline-flex gap-1" data-testid={testid}>
      <span className={`rounded px-1.5 py-0.5 text-[11px] tabular-nums ${c.errors ? "bg-red-50 text-red-700" : "bg-slate-50 text-slate-400"}`}>{c.errors} err.</span>
      <span className={`rounded px-1.5 py-0.5 text-[11px] tabular-nums ${c.warnings ? "bg-amber-50 text-amber-800" : "bg-slate-50 text-slate-400"}`}>{c.warnings} avv.</span>
    </span>
  );
}
